// @ts-nocheck

'use client'

import React, { useState } from "react";

import * as S from "./ResetPassword";

import { AuthenticationFormError } from '../AuthenticationHandler.styles'

import { SpacerBase, Container, Row, Col } from '../../../atoms/GridSystem';
import { Paragraph, Heading } from "../../../atoms/Typography/Typography.component";
import Button from "../../../atoms/Button/Button.component";
import Icon from "../../../atoms/Icon/Icon.component";
import Input from "../../../atoms/Fields/Input/Input.component";
import ModalAuth from "../../Modal/ModalAuth/ModalAuth.component";
import { useModal } from "../../../../contexts/Modal.context";
import { useUserMeta } from "../../../../contexts/UserMeta.context";
import { getPageLocale } from "@caffeina-siad/utils";

import { Formik, Form } from "formik";
import * as Yup from 'yup'

import Image from 'next/image';
import { useRouter } from "next/navigation";
import { useTranslations } from 'next-intl';

const ResetPassword = ({ webAuthClient, setTemplate }: { webAuthClient: auth0.WebAuth | null, setTemplate: (template: string) => void }): JSX.Element => {
  const router = useRouter();
  const [ formError, setFormError ] = useState(false);
  const { showModal } = useModal()
  const { handleSetUserMeta } = useUserMeta()
  const t = useTranslations();

  const handleAuth0Errors = (err) => {
    const { code } = err;

    if (code === 'invalid_grant') {
      setFormError(t('resetPassword.resetPasswordFormGeneralError'));
    }
  }

  const handleResetPassword = ({ email }) => {
    if (!webAuthClient) return;
    setFormError(false);

    webAuthClient.changePassword({
      connection: 'Username-Password-Authentication',
      email
    }, function (err, resp) {
      if(err){
        console.error('Error:', err)
        showModal(ModalAuth, {
          title: t('resetPassword.resetPasswordModalTitle'),
          description: t('resetPassword.resetPasswordModalGeneralError'),
          foreground: true
        })
      }else{
        showModal(ModalAuth, {
          title: t('resetPassword.resetPasswordModalTitle'),
          description: t('resetPassword.resetPasswordModalSuccess'),
          foreground: true,
          cta: {
            label: t('resetPassword.resetPasswordModalCta'),
            handleClick: () => {
              setTemplate('login')
            }
          }
        })
      }
    });
  }

  return (
    <S.ResetPassword>
      <Container>
        <Row>
          <Col xs={12} lg={6}>
            <Formik
              initialValues={{
                email: '',
              }}
              validationSchema={Yup.object({
                email: Yup.string().email(t('resetPassword.resetPasswordFormEmailError')).required(t('global.formErrorRequired')),
              })}
              onSubmit={(values) => handleResetPassword(values)}
            >
              {({ values, errors, touched, handleChange, handleSubmit }) => {

                return (
                  <Form>
                    <S.ResetPasswordForm>
                      <S.ResetPasswordFormIcon>
                        <Icon name={'brand-logo'} useIconColor unlockedProportions />
                      </S.ResetPasswordFormIcon>
                      <SpacerBase xs={2} />
                      <Heading
                        content={t('resetPassword.title')}
                        typo={'headingLG'}
                      />
                      <SpacerBase xs={2} />
                      <S.ResetPasswordFormRegister>
                        <Paragraph 
                          content={t('resetPassword.subtitle')}
                          typo={'buttonMD'}
                        />
                      </S.ResetPasswordFormRegister>
                      <SpacerBase xs={3} />
                      <S.ResetPasswordFormInputWrapper>
                        <Input type="text" placeholder={t('resetPassword.resetPasswordFormEmailPlaceholder')} name="email"  />
                      </S.ResetPasswordFormInputWrapper>
                      <SpacerBase xs={4} />
                      {formError ? (
                        <>
                          <AuthenticationFormError>
                            <Paragraph 
                              content={formError}
                              typo={'paragraphSM'}
                            />
                          </AuthenticationFormError>
                          <SpacerBase xs={2} />
                        </>
                      ) : null}
                      <Button 
                        label={t('resetPassword.resetPasswordCta')} 
                        variant="primary" 
                        iconEnd="arrow-right"
                        fullWidth
                        type={'submit'}
                      />
                      <SpacerBase xs={2} />
                    
                    </S.ResetPasswordForm>
                  </Form>
                )
              }}
            </Formik>
          </Col>
        </Row>
      </Container>
      <S.ResetPasswordImageWrapper>
        <Image
          src="/images/concorso.jpg"
          alt="ResetPassword Background"
          fill
        />
      </S.ResetPasswordImageWrapper>
    </S.ResetPassword>
  );
}

export default ResetPassword;
